<template>
  <div>
    <vs-button type="border" color="secondary" @click="showPopup = true">{{ label }}</vs-button>
    <popup-select736 v-model="showPopup" @select="onSelect"/>
  </div>
</template>

<script>
import PopupSelect736 from "@/views/boards/single-page/736/PopupSelect736.vue";

export default {
  components: { PopupSelect736 },
  props: {
    value: Object,
    label: {
      type: String,
      default: "공정분류 선택"
    }
  },
  computed: {
    model: {
      get () {
        return this.value;
      },
      set (val) {
        if (val) {
          this.$emit('input', {
            id: val.id,
            사업장: val.body.사업장,
            팀명: val.body.팀명,
            공장명: val.body.공장명,
            대분류: val.body.대분류,
            중분류: val.body.중분류,
            소분류: val.body.소분류,
          });
          return;
        }
        this.$emit('input', val);
      }
    }
  },
  data () {
    return {
      showPopup: false
    }
  },
  methods: {
    onSelect (model) {
      this.model = model;
    }
  }
}
</script>

<style scoped>

</style>
